import { tokens } from '../../tokens/underlyingTokens';
import type { VToken } from '../../types';

export const optimismMainnet: VToken[] = [
  {
    chainId: 10,
    address: '0x9EfdCfC2373f81D3DF24647B1c46e15268884c46',
    decimals: 8,
    symbol: 'vWBTC_Core',
    underlyingToken: tokens[10][3],
  },
  {
    chainId: 10,
    address: '0x66d5AE25731Ce99D46770745385e662C8e0B4025',
    decimals: 8,
    symbol: 'vWETH_Core',
    underlyingToken: tokens[10][4],
  },
  {
    chainId: 10,
    address: '0x37ac9731B0B02df54975cd0c7240e0977a051721',
    decimals: 8,
    symbol: 'vUSDT_Core',
    underlyingToken: tokens[10][5],
  },
  {
    chainId: 10,
    address: '0x6b846E3418455804C1920fA4CC7a31A51C659A2D',
    decimals: 8,
    symbol: 'vOP_Core',
    underlyingToken: tokens[10][2],
  },
  {
    chainId: 10,
    address: '0x1C9406ee95B7af55F005996947b19F91B6D55b15',
    decimals: 8,
    symbol: 'vUSDC_Core',
    underlyingToken: tokens[10][6],
  },
];
